import { render } from "./JournalView.vue?vue&type=template&id=a36988fe&scoped=true"
import script from "./JournalView.vue?vue&type=script&lang=js"
export * from "./JournalView.vue?vue&type=script&lang=js"

import "./JournalView.vue?vue&type=style&index=0&id=a36988fe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36988fe"]])

export default __exports__